import api, { IDataRequest, IDataResponse } from "src/framework/providers/api";
import { AProvider } from "src/framework/providers/AProvider";

class CartasCreditosProvider extends AProvider {
    constructor() {
        super("/pagamentos/cartas_credito");
    }

    async saveAtualizarCartaCredito(pagamentoId: number, data: any): Promise<IDataResponse> {
        try {
            const request: IDataRequest = {
                url: this.path + "/atualizar/" + pagamentoId,
                data: data
            }

            const response: IDataResponse = await api.put(request);

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao atualizar pagamento/carta_credito",
                statusCode: 404
            }
        }
    }

    async listCartaCredito(pagamentoId: number): Promise<IDataResponse> {
        try {
            const request: IDataRequest = {
                url: this.path + "/listar/" + pagamentoId,
            }

            const response: IDataResponse = await api.get(request);

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao atualizar pagamento/carta_credito",
                statusCode: 404
            }
        }
    }
}

const cartasCreditoProvider = new CartasCreditosProvider();
export default cartasCreditoProvider;
export { CartasCreditosProvider }